export default {
    downtimeUrl: "https://it.kodland.tech",
    startPage: {
      title:
        " Odpowiedz na tylko 4 pytania i weź udział w BEZPŁATNYM KURSIE ☃️",
      subtitle:
        "<b>Zajęcia są prowadzone w języku polskim! </b>Twoje dziecko stworzy własny projekt. Zamiast grać gry będzie je z nami tworzyć",
      button: "Ruszajmy 🚀",
      image: {
        url:  "/welcome/quiz_poland_free_course_with_new_cover_pk.png",
        style: {
          height: "100%",
          "max-height": "100vh",
        },
      },
      imageMobile: {
        url: "/welcome/quiz_poland_free_course_with_new_cover_mobile.png",
        style: {
          width: "100%",
        },
      },
    },
    successPage: {
        title:
          "Drogi Rodzicu!",
        subtitle: 'Dla dziecka w Państwa wieku przygotowaliśmy specjalną ofertę - nauczyciel ze szkoły przeprowadzi indywidualne zajęcia, na których cała uwaga i czas będzie poświęcony',
        button: "📆Dostępne terminy ➡️",
    },
    stopPage: {
        image: "/welcome/quiz_stop_page.jpg",
        title: "Dziękujemy za zainteresowanie szkołą Kodland! Nasze kursy online są przeznaczone dla dzieci i nastolatków w wieku od 8 do 17 lat <p>Zwracamy uwagę, że nasze kursy wymagają takiego sprzętu jak: klawiatura i myszka. Z tego względu telefony, tablety i urządzenia bez tych narzędzi nie są kompatybilne. Aby być na bieżąco z naszymi nowościami, możesz nas śledzić na Instagramie https://www.instagram.com/kodland.pl/ 💙",
    },
    quizRotateBySteps: {
      1: {
        question: "Ile czasu dziennie Twoje dziecko spędza używając gadżetów?",
        answers: [
            "😍 Do 2 godzin", 
            "🙂 Od 2 do 4 godzin",
            "😞 Więcej niż 4 godziny",
            "🤔 Nie pilnuję tego",
        ],
      },
      2: {
        question: "Jaki charakter ma Twoje dziecko?",
        answers: [
            "Aktywne, bardzo rozmowne", 
            "Nieśmiałe, często się wstydzi",
            "Marzycielskie, oddaje się marzeniom",
            "Ciche, spędza czas 'w sobie'",
            "Nie wie czego chce",
            "Własna wersja, opowiem na lekcji",
        ],
      },
      3: {
        question: "Na czym zależy Ci najbardziej?",
        answers: [
            "👩‍👦 Nawiązanie kontaktu z dzieckiem", 
            "🎣 Natychmiastowe rezultaty",
            "🧠 Zainteresowanie i motywacja dziecka",
            "👏 Przydatne umiejętności w przyszłości",
            "😻 Przyjazna atmosfera",
            "🖥️ Wygodna platforma edukacyjna",
        ],
      },
      4: {
        question: "Jak oceniasz poziom motywacji Twojego dziecka?",
        answers: [
          "😞 Niski",
          "🤔 Średni",
          "😍 Wysoki",
        ],
      },
      5: {
        question: "Czy posiadasz komputer stacjonarny/laptopa, z którego Twoje dziecko może skorzystać?",
        answers: [
          "✅ Tak",
          {
            answer: "❌ Nie",
            stopAnswer: true
          },
        ],
      },
      6:  {
        question: "Jakiego rodzaju projekt może być interesujący dla Twojego dziecka?",
        answers: [
            "Projektowanie swojego świata gry", 
            "Programowanie stron internetowych",
            "Projektowanie stron internetowych lub aplikacji mobilnych",
            "Modelowanie 3D i tworzenie postaci",
            "Inne rzeczy, które omówię na darmowym zajęciu",
        ],
      },
    },
  };